import { Modal, ModalProps } from "react-bootstrap";
import { TickSuccess } from "../icon";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CrossFailure from "../icon/CrossFailure";
import { getPortraitStageContainer } from "../PortraitStage";

interface FailureScanModalProps extends ModalProps {
}

const FailureScanModal = (props: FailureScanModalProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate('/')
    }, 5000);
  }, [])

  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="commonModal"
    >
      <Modal.Body className="text-center" style={{ padding: 48 }}>
        <CrossFailure />
        <div className="loaderTxtScan">
          {props.message}
        </div>
      </Modal.Body>
    </Modal >
  );
};

export default FailureScanModal;
